import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'semantic-ui-react';
import { Helmet } from "react-helmet";


import CustomDivider from '../../components/extras/CustomDivider';
import TableStockBranch from "../../components/charts/TableStockBranch";

class StockForBranchOffice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_office: ''
        }
    }

    loadData = (branch_office) => {
        this.refs.stock_branch_office.loadData(branch_office);
        this.setState({branch_office})
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Inventario por Sucursal - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section active>Inventario por Sucursal</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider />
                <TableStockBranch
                    title='Inventario'
                    id='stock_branch_office'
                    ref='stock_branch_office'
                />
            </div>
        );
    }
}

export default StockForBranchOffice;



// WEBPACK FOOTER //
// ./src/containers/reports/StockForBranchOffice.js